import * as actionTypes from '@store/actions/actionTypes';

const initialState = {
  maintenance: false,
  loading: false,
  error: null,
  success: null,
  token: null,
  email: null,
  role: null,
  company_name: null,
  name: null,
  job_title: null,
  phone: null,
  address_line_1: null,
  address_line_2: null,
  city: null,
  state: null,
  country: null,
  zip_code: null,
  is_admin: null,
  policy_types: {},
  association_types: {},
  permissions: {}
};
const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.AUTH_CLEAR:
      return {
        ...state,
        error: null,
        success: null,
        loading: false
      };
    case actionTypes.AUTH_START:
      return {
        ...state,
        error: null,
        success: null,
        loading: false
      };
    case actionTypes.AUTH_SUCCESS:
      return {
        ...state,
        error: null,
        success: null,
        loading: false,
        token: action.authData.token,
        email: action.authData.user.email,
        role: action.authData.user.role,
        company_name: action.authData.user.company_name,
        name: action.authData.user.name,
        job_title: action.authData.user.job_title,
        phone: action.authData.user.phone,
        address_line_1: action.authData.user.address_line_1,
        address_line_2: action.authData.user.address_line_2,
        city: action.authData.user.city,
        state: action.authData.user.state,
        country: action.authData.user.country,
        zip_code: action.authData.user.zip_code,
        is_admin: action.authData.user.is_admin,
        policy_types: action.authData.policy_types,
        association_types: action.authData.association_types,
        permissions: action.authData.permissions
      };
    case actionTypes.AUTH_FAIL:
      return {
        ...state,
        error: action.error,
        success: null,
        loading: false
      };
    case actionTypes.AUTH_LOGOUT:
      return {
        ...initialState
      };
    default:
      return state;
  }
};

export default reducer;
